module.exports = __webpack_public_path__ + "static/img/beizhengshouhu_0011.b06c887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beizhengshouhu_0011.png
// module id = fvs4
// module chunks = 1